"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = mq;

var _init = _interopRequireDefault(require("./_init"));

var _parsehtml = _interopRequireDefault(require("./parsehtml"));

var _on = _interopRequireDefault(require("./on"));

var _off = _interopRequireDefault(require("./off"));

var _add = _interopRequireDefault(require("./add"));

var _assign = _interopRequireDefault(require("../../_helpers/assign"));

// tiny jQuery replacement for Seemple
function mq(selector, context) {
  return new _init["default"](selector, context);
}

mq.parseHTML = _parsehtml["default"];
(0, _assign["default"])(_init["default"].prototype, {
  on: _on["default"],
  off: _off["default"],
  add: _add["default"]
});
//# sourceMappingURL=index.js.map